import React from 'react';

const NavBar = () => {
    return (
        <section>
            <p className='footer'> designed & coded by mindy mohr Ⓒ 2021-2026 </p>
        </section>
    )
}

export default NavBar;